import { combineReducers } from "redux";
import { ProductInterface } from "../interfaces/products";

interface GetProductsPayload extends Array<ProductInterface> {}

export type ProductsAction =
    | { type: "GET_PRODUCTS_START" }
    | { type: "GET_PRODUCTS_SUCCESS"; payload: GetProductsPayload }
    | { type: "GET_PRODUCTS_ERROR" }
    | { type: "BUY_COMPANY_PRODUCT_START" }
    | { type: "BUY_COMPANY_PRODUCT_SUCCESS"; payload: any }
    | { type: "BUY_COMPANY_PRODUCT_ERROR" };

interface ProductsState {
    result: Array<ProductInterface>;
    isGettingProducts: boolean;
    isBuyingProduct: boolean;
}

const initialState: ProductsState = {
    result: [],
    isGettingProducts: false,
    isBuyingProduct: false,
};

const isGettingProducts = (
    state = initialState.isGettingProducts,
    action: ProductsAction,
) => {
    switch (action.type) {
        case "GET_PRODUCTS_START":
            return true;
        case "GET_PRODUCTS_SUCCESS":
            return false;
        case "GET_PRODUCTS_ERROR":
            return false;
        default:
            return state;
    }
};

const isBuyingProduct = (
    state = initialState.isBuyingProduct,
    action: ProductsAction,
) => {
    switch (action.type) {
        case "BUY_COMPANY_PRODUCT_START":
            return true;
        case "BUY_COMPANY_PRODUCT_SUCCESS":
            return false;
        case "BUY_COMPANY_PRODUCT_ERROR":
            return false;
        default:
            return state;
    }
};

const data = (state = initialState.result, action: ProductsAction) => {
    switch (action.type) {
        case "GET_PRODUCTS_START":
            return [];
        case "GET_PRODUCTS_SUCCESS":
            return action.payload;
        case "GET_PRODUCTS_ERROR":
            return [];
        default:
            return state;
    }
};

const products = combineReducers({ isGettingProducts, isBuyingProduct, data });

export default products;
